<template>
    <div>
        
    </div>
</template>

<script>
export default {
    mounted() {
        // let url = decodeURIComponent(this.$route.params.url) 
        // let data = JSON.parse(this.$route.params.params)

        // console.log(url,data)
        const url = 'https://media.smgtech.net:8443/radio/original/2020/10/30/32a22cf0-1a4d-11eb-ace1-0050569c5c7a.mxf'
        const fileStream = streamSaver.createWriteStream('cat.mp4')

        fetch(url).then(res => {
          const readableStream = res.body

          // more optimized
          if (window.WritableStream && readableStream.pipeTo) {
            return readableStream.pipeTo(fileStream)
              .then(() => console.log('done writing'))
          }

          window.writer = fileStream.getWriter()

          const reader = res.body.getReader()
          const pump = () => reader.read()
            .then(res => res.done
              ? writer.close()
              : writer.write(res.value).then(pump))

          pump()
        })
    }
}
</script>

